<template>
    <div id="main">
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{
                        $t(
                            isUpdate
                                ? "edit-vinculo-unidade-medida"
                                : "insert-vinculo-unidade-medida"
                        )
                    }}
                </h1>
            </div>
            <div class="header-buttons">
                <button class="delete-btn" type="button" @click="onFecharModal">
                    {{ $t("cancelar") }}
                </button>
                <button class="save-btn" type="button" @click="save">
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>

        <div class="columns form-columns-fit is-flex-wrap">
            <div class="column is-6">
                <div class="perc-input">
                    <v-input
                        :id="generateId(2)"
                        v-model="percentualreajuste"
                        placeholder="placeholder-preencha"
                        :msg="'porcentagem-invalida'"
                        :invalid="invalidReajuste"
                        :onBlurFunction="validateReajuste"
                        :maxlength="6"
                        ref="reajusteFobInput"
                        validchars="0123456789."
                        title="perc-reajuste"
                        tooltipSize="is-small"
                        icon="percent"
                        porcentagem
                    />
                </div>
            </div>
            <div class="column is-6">
                <div class="fator-input">
                    <v-input
                        :id="generateId(3)"
                        v-model="fatorconversaoestoque"
                        placeholder="placeholder-preencha"
                        :msg="'porcentagem-invalida'"
                        :invalid="invalidReajuste"
                        :onBlurFunction="validateConversao"
                        :maxlength="6"
                        ref="reajusteFobInput"
                        validchars="0123456789."
                        title="perc-reajuste"
                        tooltipSize="is-small"
                        icon="percent"
                        porcentagem
                    />
                </div>
            </div>
        </div>
        <div class="tabela" v-if="!isEdit">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("vincular-unidade-medida") }}
                        </h1>
                    </div>
                </div>
            </div>

            <div class="search-and-filter">
                <div class="search-bar">
                    <search-bar
                        :onSearch="debouncedOnSearch"
                    />
                </div>
            </div>

            <div class="registry-wrapper">
                <container-loader
                    v-if="isLoading && !$store.getters.isLoading"
                />
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="unidadesMedidas"
                    class="data-table"
                    checkable
                    :checked-rows.sync="unidadesMedidasSelecionadas"
                    :custom-is-checked="
                        (selecionados, unidades) =>
                            selecionados.unidademedida.idunidademedida ===
                            unidades.unidademedida.idunidademedida
                    "
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="$t(f.key)"
                        :width="f.width"
                        :sortable="f.sortable"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'descricao'">
                            <a @click="select(props.row)">
                                {{ props.row[f.key] }}
                            </a>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>

                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
        </div>
    </div>
</template>

<script>
import VenProdutoService from "@/services/vendas/produto/VenProdutoService";
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    components: {
        ContainerLoader,
    },
    props: {
        selected: {
            type: Object,
            default: () => {},
        },
        isUpdate: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            service: new VenProdutoService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            percentualreajuste: 0,
            fatorconversaoestoque: 0,
            unidadesMedidas: [],
            unidadesMedidasSelecionadas: [],
            isEmpty: false,
            fields: [
                {
                    key: "descricao",
                    width: null,
                    sortable: false,
                    sortFn: null,
                },
            ],
            debouncedOnSearch: null,
            queryFilter: "",
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            msgs: [],
            isEdit: false,
            idproduto: 0,
            invalidReajuste: false,
            invalidConversao: false,
        };
    },
    created() {
        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];

        this.idproduto = this.$route.params.id;

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);

        if (this.selected != null) {
            this.isEdit = true;
            this.percentualreajuste = this.selected.percentualreajuste;
            this.fatorconversaoestoque = this.selected.fatorconversaoestoque;
        } else {
            this.carregarDados();
        }
    },
    methods: {
        validateReajuste() {
            this.invalidReajuste = !this.validatePorcentagem(
                this.percentualreajuste
            );
        },
        validateConversao() {
            this.invalidConversao = !this.validatePorcentagem(
                this.fatorconversaoestoque
            );
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }

            this.isLoading = true;

            this.service
                .loadUnidadesMedidasDisponiveis(
                    this.idproduto,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.queryFilter
                )
                // .then(this.mapItems)
                .then((value) => {
                    this.unidadesMedidas = value.content;
                    this.isEmpty = this.unidadesMedidas.length === 0;
                    this.pagination.totalRows = value.totalElements;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-load");
                    console.error("Erro ao carregar os dados.");
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },

        generateId(numberId) {
            return this.$route.name + "-unidademedida-" + numberId;
        },
        save() {
            this.isLoading = true;

            if (!this.isEdit) {
                if (this.unidadesMedidasSelecionadas.length > 0) {
                    this.unidadesMedidasSelecionadas.forEach((um) => {
                        um.idproduto = this.idproduto;
                        um.fatorconversaoestoque = this.fatorconversaoestoque;
                        um.percentualreajuste = this.percentualreajuste;
                    });

                    this.service
                        .addListUnMedidas(this.unidadesMedidasSelecionadas)
                        .then((value) => {
                            if (value.status === 409) {
                                this.$root.showMessage(
                                    "alert",
                                    `${value.message}`
                                );
                            } else if (value.status === 500) {
                                this.$root.showMessage(
                                    "error",
                                    `${value.message}`
                                );
                            } else {
                                this.$root.showMessage(
                                    "success",
                                    "msg-sucesso-ao-adicionar-associacao"
                                );
                                setTimeout(() => {
                                    this.$emit("sucesso", true);
                                    this.$emit("fecharModal", true);
                                }, 200);
                            }
                        })
                        .catch((e) => {
                            console.error(e);
                            this.$root.showMessage("alert", "msg-erro-load");
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                } else {
                    this.$root.showMessage("error", "msg-selecione-usuario");
                    this.isLoading = false;
                }
            } else {
                this.selected.percentualreajuste = this.percentualreajuste;
                this.selected.fatorconversaoestoque =
                    this.fatorconversaoestoque;
                let list = [this.selected];

                this.service
                    .addListUnMedidas(list)
                    .then((value) => {
                        if (value.content === null) {
                            this.$root.showMessage("error", `${value.message}`);
                        } else {
                            this.$root.showMessage(
                                "success",
                                "msg-sucesso-ao-editar-associcao"
                            );
                            setTimeout(() => {
                                this.$emit("fecharModal", true);
                            }, 200);
                        }
                    })
                    .catch((e) => {
                        this.$root.showMessage("alert", "msg-erro-load");
                        console.error(e);
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            }
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        select(selected) {
            this.$emit("selected", selected);
        },
        onFecharModal() {
            this.$emit("fecharModal", true);
        },
    },
};
</script>


<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>
